import React, {ReactNode} from 'react';

export const CustomDialogComponent = ({children, onBlur, width}: {
    children: ReactNode;
    onBlur?: (event: React.FocusEvent<HTMLDivElement>) => void;
    width?: string;
}) => {

    return (
        <div
            className="fixed inset-0 bg-gray-600 bg-opacity-50 z-50 overflow-y-auto h-full w-full flex items-center justify-center transition-all duration-300">
            <div
                onBlur={onBlur}
                className={`${width ?? 'w-full max-w-sm'} p-2 mx-3 bg-white border border-stone-200 dark:border-stone-700 rounded-2xl shadow-2xl sm:p-3 dark:bg-stone-800`}>
                {children}
            </div>
        </div>
    );
};